import { render, staticRenderFns } from "./TiptapEditor.vue?vue&type=template&id=78b2f5d4"
import script from "./TiptapEditor.vue?vue&type=script&lang=ts"
export * from "./TiptapEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports